export default {
  root: {},
  elevation1: {
    boxShadow: '0px 4px 15px rgb(31 33 37 / 10%)'
  },
  elevation4: {
    boxShadow: '0px 10px 20px rgb(31 33 37 / 20%)'
  },
  elevation8: {
    boxShadow:
      '0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 20px 14px 2px rgb(0 0 0 / 12%)'
  },
  rounded: {
    borderRadius: 8
  }
}
